import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";
import { Skeleton } from "@/components/ui/skeleton";

function AuthSkeleton() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <div className="space-y-4 text-center">
        <Skeleton className="mx-auto h-10 w-10 rounded-full" />
        <Skeleton className="mx-auto h-4 w-48" />
      </div>
    </div>
  );
}

export function RequireAuth() {
  const { user, profile, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return <AuthSkeleton />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admins bypass subscription check
  if (!isAdmin && profile) {
    const hasSubscription = !!profile.subscription_source;
    const isExpired =
      profile.subscription_period_end &&
      new Date(profile.subscription_period_end) < new Date();

    if (!hasSubscription || isExpired) {
      return <Navigate to="/expired" replace />;
    }
  }

  return <Outlet />;
}
